import React from 'react';
import { List, Datagrid, TextField, DateField, useListContext, Link } from 'react-admin';
import Typography from '@material-ui/core/Typography';

import ShipmentSearchAside from './ShipmentSearchAside';
import useSupplyStyles from '../controls/SupplyStyles';
import ErrorBoundary from '../ErrorBoundary';

const STATUS_LABEL = {
    OPEN: 'Open',
    FINALIZED: 'Finalized',
    CANCELLED: 'Cancelled',
};

const FoundHeader = () => {
    const classes = useSupplyStyles();
    const { total } = useListContext();
    return (
        <Typography className={classes.sectionTitle}>
            {total || 0} supply shipment{total === 1 ? '' : 's'} found.
        </Typography>
    );
};

const ManifestLinkField = ({ record }) =>
    record ? (
        <Link to={`/supplyshipments/${record.id}/show`}>
            {record.manifest_no || '(open)'}
        </Link>
    ) : null;
ManifestLinkField.defaultProps = { label: 'Manifest #', source: 'manifest_no' };

const StatusField = ({ record }) =>
    record ? <span>{STATUS_LABEL[record.status] || record.status}</span> : null;
StatusField.defaultProps = { label: 'Status', source: 'status' };

const ShipmentContent = props => (
    <React.Fragment>
        <FoundHeader />
        <Datagrid {...props}>
            <ManifestLinkField />
            <DateField source="ship_date" label="Ship Date" />
            <DateField source="receipt_date" label="Receipt Date" />
            <TextField source="origin" label="Origin" />
            <StatusField />
            <TextField source="po_no" label="PO #" />
            <TextField source="ref_no" label="Ref #" />
            <TextField source="line_count" label="Lines" />
        </Datagrid>
    </React.Fragment>
);

const ShipmentList = props => {
    const classes = useSupplyStyles();
    return (
        <ErrorBoundary>
            <List
                {...props}
                title="Supply Shipments"
                classes={{ main: classes.asideLeft }}
                aside={<ShipmentSearchAside />}
                filterDefaultValues={{ status: 'FINALIZED' }}
                perPage={25}
                sort={{ field: 'receipt_date', order: 'DESC' }}
                bulkActionButtons={false}
                empty={false}
                exporter={false}
            >
                <ShipmentContent />
            </List>
        </ErrorBoundary>
    );
};

export default ShipmentList;
